import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { DottedOutlineCircleIcon } from '~/ui/core/icons';

import { ReviewSection } from './ReviewSection';

export const DraftBadge: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <ReviewSection data-testid="review-state-draft">
            <DottedOutlineCircleIcon height={12} width={12} />
            <span>{translate('pages.job-architecture-v2.review-state.draft')}</span>
        </ReviewSection>
    );
};
